import React, { useState } from "react";
import "./Settings.scss";
import SettingsSidebar from "./SettingsSidebar";

const PhoneSettings = () => {
  const [phoneNumbers, setPhoneNumbers] = useState([
    { 
      number: "+49 123 456789",
      type: 'primary',
      country: 'DE',
      callHours: '09:00 - 18:00',
      forward: false
    },
    {
      number: "+1 555 1234567",
      type: 'secondary',
      country: 'US',
      callHours: '24/7',
      forward: true
    }
  ]);

  const [newNumber, setNewNumber] = useState({
    number: '',
    country: 'DE',
    type: 'secondary',
    callHours: '09:00 - 18:00',
    forward: false,
    voicemail: true
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setPhoneNumbers([...phoneNumbers, newNumber]);
    setNewNumber({
      ...newNumber,
      number: '',
      country: 'DE'
    });
  };

  return (
    <div className="settings-container">
  <SettingsSidebar />

      <div className="settings-content">
        <div className="phone-settings-section">
          <h2>Telefonie-Einstellungen</h2>

          <div className="existing-numbers modern-card">
            <h3>Registrierte Nummern</h3>
            <div className="number-grid">
              {phoneNumbers.map((num, index) => (
                <div key={index} className="number-card">
                  <div className="number-info">
                    <div className="number-type">{num.type === 'primary' ? '⭐' : ''} {num.type}</div>
                    <div className="number-display">
                      <span className="country-flag">{num.country}</span>
                      {num.number}
                    </div>
                    <div className="call-hours">
                      <i className="fa-regular fa-clock"></i>
                      {num.callHours}
                    </div>
                  </div>
                  <div className="number-actions">
                    <button className="set-primary">
                      {num.type === 'primary' ? 'Primär' : 'Als primär festlegen'}
                    </button>
                    <button className="edit-btn">
                      <i className="fa-regular fa-pen-to-square"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <form className="number-form modern-card" onSubmit={handleSubmit}>
            <h3>Neue Nummer hinzufügen</h3>
            
            <div className="form-grid">
              <div className="input-group">
                <label>Telefonnummer</label>
                <input
                  type="tel"
                  value={newNumber.number}
                  onChange={(e) => setNewNumber({...newNumber, number: e.target.value})}
                  pattern="[+][0-9]{1,4} [0-9]{3,} [0-9]{5,}"
                  required
                  placeholder="+49 123 456789"
                />
              </div>

              <div className="input-group">
                <label>Land</label>
                <select
                  value={newNumber.country}
                  onChange={(e) => setNewNumber({...newNumber, country: e.target.value})}
                >
                  <option value="DE">Deutschland</option>
                  <option value="AT">Österreich</option>
                  <option value="CH">Schweiz</option>
                  <option value="US">USA</option>
                </select>
              </div>

              <div className="input-group">
                <label>Nummerntyp</label>
                <div className="type-select">
                  <button
                    type="button"
                    className={newNumber.type === 'primary' ? 'active' : ''}
                    onClick={() => setNewNumber({...newNumber, type: 'primary'})}
                  >
                    Primär
                  </button>
                  <button
                    type="button"
                    className={newNumber.type === 'secondary' ? 'active' : ''}
                    onClick={() => setNewNumber({...newNumber, type: 'secondary'})}
                  >
                    Sekundär
                  </button>
                </div>
              </div>

              <div className="input-group">
                <label>Erreichbarkeit</label>
                <select
                  value={newNumber.callHours}
                  onChange={(e) => setNewNumber({...newNumber, callHours: e.target.value})}
                >
                  <option value="09:00 - 18:00">Werktags 09-18 Uhr</option>
                  <option value="24/7">24/7 Erreichbar</option>
                  <option value="custom">Benutzerdefiniert</option>
                </select>
              </div>
            </div>

            <div className="advanced-settings">
              <h4>Erweiterte Einstellungen</h4>
              
              <div className="toggle-group">
                <label>
                  <input
                    type="checkbox"
                    checked={newNumber.forward}
                    onChange={(e) => setNewNumber({...newNumber, forward: e.target.checked})}
                  />
                  Anrufweiterleitung aktiv
                </label>

                <label>
                  <input
                    type="checkbox"
                    checked={newNumber.voicemail}
                    onChange={(e) => setNewNumber({...newNumber, voicemail: e.target.checked})}
                  />
                  Voicemail aktivieren
                </label>
              </div>

              <div className="sip-integration">
                <h5>SIP-Integration</h5>
                <input
                  type="text"
                  placeholder="SIP-Benutzername"
                  className="sip-input"
                />
                <input
                  type="password"
                  placeholder="SIP-Passwort"
                  className="sip-input"
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="save-btn">
                Nummer speichern
              </button>
              <button type="button" className="test-btn">
                Anruftest starten
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PhoneSettings;
